export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<g clip-path="url(#clip0_134_5515)">
			<path
				d="M18.5625 9.5C18.5625 5.89062 15.6094 2.9375 12 2.9375C8.34961 2.9375 5.4375 5.89062 5.4375 9.5C5.4375 10.1562 5.64258 11.0176 6.09375 12.125C6.54492 13.1914 7.16016 14.3398 7.89844 15.4883C9.29297 17.7441 10.9336 19.918 12 21.2305C13.0254 19.918 14.666 17.7441 16.1016 15.4883C16.7988 14.3398 17.4141 13.1914 17.8652 12.125C18.3164 11.0176 18.5625 10.1562 18.5625 9.5ZM19.875 9.5C19.875 13.1094 15.0762 19.4668 12.9434 22.1328C12.4512 22.748 11.5078 22.748 11.0156 22.1328C8.92383 19.4668 4.125 13.1094 4.125 9.5C4.125 5.15234 7.65234 1.625 12 1.625C16.3477 1.625 19.875 5.15234 19.875 9.5ZM10.0312 9.5C10.0312 10.2383 10.4004 10.8535 11.0156 11.2227C11.5898 11.5918 12.3691 11.5918 12.9844 11.2227C13.5586 10.8535 13.9688 10.2383 13.9688 9.5C13.9688 8.80273 13.5586 8.1875 12.9844 7.81836C12.3691 7.44922 11.5898 7.44922 11.0156 7.81836C10.4004 8.1875 10.0312 8.80273 10.0312 9.5ZM12 12.7812C10.8105 12.7812 9.74414 12.166 9.12891 11.1406C8.55469 10.1562 8.55469 8.88477 9.12891 7.85938C9.74414 6.875 10.8105 6.21875 12 6.21875C13.1484 6.21875 14.2148 6.875 14.8301 7.85938C15.4043 8.88477 15.4043 10.1562 14.8301 11.1406C14.2148 12.166 13.1484 12.7812 12 12.7812Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_134_5515">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
